import React from "react";
import "./TextInput.css";

class EmailInput extends React.Component {

  constructor(props) {
    super(props);
  }

  onFocusHadler = e => {
    if(this.input && this.input.inputElement) {
      this.input.inputElement.select()
    }
  }

  value() {
    return this.emailInput.value;
  }

  render() {
    return (
      <input
        ref={input => {
          this.emailInput = input;
        }}
        
        className="ha-tf"
        id="emailInput"
        onFocus={this.onFocusHadler}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        value={this.props.email}
        type="text"
        placeholder="Email"
        autoComplete="off"
        autoCapitalize = 'none'
      />
    );
  }
}

export default EmailInput;

